<template>
  <div class="head-content">
    <div class="logo" @click="toHome">
      <img src="/static/logo-white.png" alt="">
    </div>
    <div class="right-view">
      <!--      <div class="date">-->
      <!--        <img src="/static/date.png" alt="">-->
      <!--        <span>北京：2021年03月15日 周一</span>-->
      <!--      </div>-->
       <el-tooltip class="item"  content="修改密码" placement="bottom" effect="light">
           <div class="set" @click="set" >
             <img src="/static/set.png" alt="">
           </div>
      </el-tooltip>
      <div class="logout" @click="out">
        <img src="/static/logout.png" alt="">
        <span>退出</span>
      </div>
    </div>
    <msgDialog :showErrorIcon="true" width="500px" title="修改密码"  @close="isShow = false" :visible.sync="isShow">
      <div class="dialog-content" >
        <el-form ref="form" :model="form" label-width="80px" :rules="rules" style="margin-left:40px">
          <el-form-item label="登录账号">
            <el-input type="text" disabled size="small" v-model="psnAccountShow" style="width:262px"></el-input>
          </el-form-item>
          <el-form-item label="原密码" prop="oldPwd">
            <el-input type="password" size="small" v-model="form.oldPwd" show-password style="width:262px"></el-input>
          </el-form-item>
          <el-form-item label="新密码" prop="newPwd">
            <el-input type="password" size="small" v-model="form.newPwd" show-password style="width:262px"></el-input>
          </el-form-item>
          <el-form-item label="密码确认" prop="newPwd2">
            <el-input type="password" size="small" v-model="form.newPwd2" show-password style="width:262px"></el-input>
          </el-form-item>
          <el-form-item>
            <div class="tip el-icon-warning" style="margin:0 30px 0 0;font-size: 12px;line-height:20px">
              密码至少8-16个字符，至少1个大写字母，1个小写字母和1个数字
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" >
        <el-button @click="cancal" size="small">取 消</el-button>
        <el-button type="primary" @click="submit" size="small">确 定</el-button>
      </div>
    </msgDialog>
<!--    <el-dialog width="500px" title="修改密码" :visible.sync="isShow">-->
<!--      <div class="dialog-content" >-->
<!--        <el-form ref="form" :model="form" label-width="80px" :rules="rules" style="margin-left:40px">-->
<!--          <el-form-item label="原密码" prop="oldPwd">-->
<!--            <el-input type="password" size="small" v-model="form.oldPwd" show-password style="width:262px"></el-input>-->
<!--          </el-form-item>-->
<!--          <el-form-item label="新密码" prop="newPwd">-->
<!--            <el-input type="password" size="small" v-model="form.newPwd" show-password style="width:262px"></el-input>-->
<!--          </el-form-item>-->
<!--          <el-form-item label="密码确认" prop="newPwd2">-->
<!--            <el-input type="password" size="small" v-model="form.newPwd2" show-password style="width:262px"></el-input>-->
<!--          </el-form-item>-->
<!--        </el-form>-->
<!--            <div class="tip el-icon-warning" style="margin-left:50px">-->
<!--              密码至少8-16个字符，至少1个大写字母，1个小写字母和1个数字-->
<!--            </div>-->
<!--      </div>-->

<!--      <div slot="footer" class="dialog-footer">-->
<!--        <el-button @click="cancal" size="small">取 消</el-button>-->
<!--        <el-button type="primary" @click="submit" size="small">确 定</el-button>-->
<!--      </div>-->
<!--    </el-dialog>-->
  </div>
</template>

<script>
import { modifyPwd } from "@/util/api";
import msgDialog from "./business/msgDialog";
  export default {
    name: "myHeader",
    components:{
      msgDialog
    },
    created() {
      this.psnAccountShow = window.localStorage.getItem("psnAccountShow");
    },
    data(){
      return{
        psnAccountShow: null,
        isShow:false,
        form:{},
        rules: {
          oldPwd: [
            { required: true, message: '请输入原密码', trigger: ['change', 'blur'] },
          ],
          newPwd: [
            { required: true, message: '请输入新密码', trigger: ['change', 'blur']},
            {
							validator: (rule, value, callback) => {
								var reg = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^]{8,16}$/
								var flag = reg.test(value)
								if(!flag){
                  callback(new Error('密码至少8-16个字符，至少1个大写字母，1个小写字母和1个数字'));
                }else{
                  callback();
                }
							},
							trigger: ['change', 'blur'],
            },
            {
							validator: (rule, value, callback) => {
								if (value == this.form.oldPwd) {
                  callback(new Error('原密码和新密码不能一致'));
                }else{
                  callback();
                }
							},
							trigger: ['change', 'blur'],
						}
          ],
          newPwd2: [
            { required: true, message: '请再次确认新密码', trigger: 'blur' },
          	{
							validator: (rule, value, callback) => {
								if (value != this.form.newPwd){
                  callback(new Error('两次输入的密码不相等'));
                }else{
                  callback();
                }
							},
							trigger: ['change', 'blur'],
						}
          ]
        }
      }
    },
    methods: {
      out() {
        window.localStorage.removeItem('token')
        window.localStorage.removeItem('menus')
        this.$router.push('/login')
      },

      toHome(){
        // console.log(this.$router.options.routes[0].children[0].path)
        this.$router.push(this.$router.options.routes[0].children[0].path)
      },
      set(){
        this.isShow=true;
      },
      submit(){
        this.$refs['form'].validate((valid) => {
          if (valid) {
          if(this.form.newPwd!=this.form.newPwd2){
            this.$message.error('两次输入的密码不一致')
            return false;
        }
          modifyPwd({'passwd':this.form.oldPwd,'newpasswd':this.form.newPwd}).then(res => {
            if (res.success) {
              this.$message.success('修改成功')
              this.isShow=false
              this.form={}
            }else{
              this.$message.error(res.msg)
            }
          });
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      cancal(){
        this.isShow=false;
        this.form={}
      }
    }
  }
</script>
<style lang="scss" scoped>
@import "src/common/common";
@import "src/common/form";
.head-content{
  width: 100%;
  height: 100%;
  .logo{
    width: 220px;
    height:  100%;
    background-color: #c81432;
    display: flex;
    justify-content: center;
    align-items: center;
    float: left;
    margin-left: 0;
    cursor: pointer;
    img{
      //width: 10vw;
      height: 42px;
    }
  }
  .right-view{
    display: flex;
    align-items: center;
    float: right;
    height: 100%;
    .date{
      height: 100%;
      display: flex;
      align-items: center;
      margin-right: 64px;
      img{
        width: 0.938vw;
        height: 0.833vw;
      }
      span{
        font-size: 0.729vw;
        font-family: PingFangSC;
        font-weight: 400;
        color: #ffffff;
        margin-left: 0.26vw;

      }
    }
    .set{
      height: auto;
      display: flex;
      justify-content: center;align-items: center;
      cursor: pointer;
      margin-right: 30px;
      img{
        width: 16px;
        height: 16px;
      }
    }
    .logout{
      height: 100%;
      display: flex;
      align-items: center;
      margin-right: 30px;
      cursor: pointer;
      img{
        width: 15px;
        height:15px;
      }
      span{
        font-size: 15px;
        font-family: PingFangSC;
        font-weight: 400;
        color: #ffffff;
        margin-left: 0.26vw;

      }
    }
  }

}
.dialog-content{
  width: 90%;

}

.tip{
  margin: 0 20px;
  color: #888;
}
  /deep/ .el-dialog__body{
    padding-bottom: 0;
  }

</style>



// WEBPACK FOOTER //
// src/components/myHeader.vue